import * as React from "react";
import * as Ons from "react-onsenui";
import { isLoading, Loading } from "../../../Loading";
import { ScheduledVisitEditRequestId } from "../../../messages/ObjectIds";
import { ScheduledVisitEditRequestType } from "../../../messages/ScheduledVisitEditRequest";
import { STRINGS } from "../../../strings";
import { AppVisitEditRequestsState } from "../../../system/AppState/AppVisitEditRequestsState";
import { globalize, translate } from "../../../translate";
import { reverseOrd } from "../../../utils/OrdTuple";
import { EmptyScreenPlaceholder } from "../../EmptyScreenPlaceholder";
import { ScreenSkeleton } from "../../ScreenSkeleton";
import { EditRequestScreenTimeComponent } from "./EditRequestScreenTimeComponent";
import { RequestStatusComponent } from "./RequestStatusComponent";

export interface EditRequestsScreenProps {
  requests: AppVisitEditRequestsState | Loading;
  onRequestClick: () => void;
  onBackClick: () => void;
}

export interface EditRequestsScreenState {}

export class EditRequestsScreen extends React.Component<
  EditRequestsScreenProps,
  EditRequestsScreenState
> {
  constructor(props: EditRequestsScreenProps) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <ScreenSkeleton
        onBackClick={this.props.onBackClick}
        title={translate(STRINGS.RESCHEDULE_REQUESTS)}
        titleBarStyle={ScreenSkeleton.TitleBarStyle.PRIMARY}
      >
        {isLoading(this.props.requests) ? (
          <div className="EditRequestsScreen__loading">
            <Ons.ProgressCircular indeterminate={true} />
          </div>
        ) : this.props.requests.visitEditRequests.isEmpty() ? (
          <EmptyScreenPlaceholder
            placeholderText={translate(STRINGS.THERE_SEEMS_TO_BE_NOTHING_HERE)}
          />
        ) : (
          <div className="EditRequestsScreen__body">
            {this.props.requests.visitEditRequests
              .sortBy((request) => reverseOrd(request.editRequestParams.createdAt))
              .map((request) => (
                <div
                  key={ScheduledVisitEditRequestId.unwrap(request.editRequestParams.requestId)}
                  className="EditRequestsScreen__card"
                  onClick={() => this.props.onRequestClick()}
                >
                  <div className="EditRequestsScreen__cardHeader">
                    {request.patientName}
                    <br />
                  </div>
                  <div className="EditRequestsScreen__cardBody">
                    <b>{translate(STRINGS.REQUEST_DETAILS)}:</b>
                    <div className="EditRequestsScreen__cardBodyPart">
                      <div>
                        <b>{translate(STRINGS.CREATED_AT)}:</b>{" "}
                        {globalize().formatInstant(request.editRequestParams.createdAt, {
                          date: "long",
                        })}
                      </div>
                      {request.editRequestParams.requestParams.type ===
                      ScheduledVisitEditRequestType.CANCEL ? (
                        ""
                      ) : (
                        <div>
                          <EditRequestScreenTimeComponent
                            scheduledTime={request.scheduledVisitDetails.scheduledStartTimeLocal}
                            requestedTime={request.editRequestParams.requestParams.startTime}
                            title={translate(STRINGS.START_TIME) + ":"}
                          />
                          <EditRequestScreenTimeComponent
                            scheduledTime={request.scheduledVisitDetails.scheduledEndTimeLocal}
                            requestedTime={request.editRequestParams.requestParams.endTime}
                            title={translate(STRINGS.END_TIME) + ":"}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="EditRequestsScreen__requestStatus">
                    <RequestStatusComponent request={request.editRequestParams}>
                      {request.editRequestParams.response === null ? (
                        ""
                      ) : (
                        <div className="EditRequestsScreen__requestStatusDetails">
                          <div className="EditRequestsScreen__cardBodyPart">
                            <b>{translate(STRINGS.ANSWERED_AT)}: </b>{" "}
                            {globalize().formatInstant(
                              request.editRequestParams.response.createdAt,
                              { date: "long" }
                            )}
                            {request.editRequestParams.response.params.message === "" ? (
                              ""
                            ) : (
                              <div>
                                <b>{translate(STRINGS.MESSAGE)}:</b>
                                <div className="EditRequestsScreen__cardBodyPart">
                                  {request.editRequestParams.response.params.message}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </RequestStatusComponent>
                  </div>
                </div>
              ))}
          </div>
        )}
      </ScreenSkeleton>
    );
  }
}
